import { useEffect, useRef } from 'react'

export const usePrevious = <T extends unknown>(value: T): T | undefined => {
    const ref = useRef<T>()
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}

type GroupByObj<T> = {
    [index: string] : T[]
}

export const GroupBy = <T extends unknown>(array: T[], funcProp: (o: T) => string): GroupByObj<T> => {
    return array.reduce<GroupByObj<T>>((acc: GroupByObj<T>, val: T) => {
        (acc[funcProp(val)] = acc[funcProp(val)] || []).push(val)
        return acc
    }, {})
}

export function countActiveFilters<T extends Record<string, any>>(filters: T, keysToCheck: string[]) {
  let count = 0;

  // Status filter logic
  const hasStatusFilter = !!filters.status;
  if (hasStatusFilter && filters.status.toLowerCase() !== 'active') count++;

  // Grouped filters logic
  const hasDateFilter = !!filters.startDate || !!filters.endDate;
  if (hasDateFilter) count++;

  const hasCountyFilter = (Array.isArray(filters.counties) && filters.counties.length > 0) || !!filters.countiesState;
  if (hasCountyFilter) count++;

  // Remove status and grouped keys from keysToCheck
  const groupedKeys = ['status', 'startDate', 'endDate', 'counties', 'countiesState'];
  const remainingKeys = keysToCheck.filter(key => !groupedKeys.includes(key));

  // Count remaining filters
  for (const key of remainingKeys) {
    const value = filters[key];
    if (Array.isArray(value)) {
      count += value.length > 0 ? 1 : 0;
    } else {
      count += value !== null && value !== undefined && !(typeof value === 'string' && value === '') ? 1 : 0;
    }
  }

  return count;
}